export default __webpack_public_path__ + "static/blob5-e0a4788f1eed4931b1e199bb86be6456.svg";